import React, { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import "./VideoPlayer.css";
import MaterialIcon from "../MaterialIcon/MaterialIcon.js";

function VideoPlayer({ url }) {
  const [playing, setPlaying] = useState(false);
  const [showPlayButton, setShowPlayButton] = useState(true);
  const playerRef = useRef(null);

  useEffect(() => {
    setShowPlayButton(!playing);
  }, [playing]);

  const handlePause = () => {
    setPlaying(false);
    console.log("playing", false);
  };
  const handlePlay = () => {
    setPlaying(true);
    console.log("playing", true);
  };

  const handleProgress = (state) => {
    // Sie können den Fortschrittszustand hier verarbeiten
  };

  const handleFullscreen = () => {
    if (playerRef.current) {
      playerRef.current.wrapper.requestFullscreen();
    }
  };
  return (
    <div className="player-wrapper">
      <ReactPlayer
        ref={playerRef}
        url={url}
        playing={playing}
        onProgress={handleProgress}
        controls={true}
        width="100%"
        height="100%"
        className="react-player"
        onPause={handlePause}
        onPlay={handlePlay}
      />

      <MaterialIcon
        name="play_circle"
        className={`play-button${showPlayButton ? " show" : ""}`}
        onClick={() => {
          setPlaying(!playing);
        }}
      />
    </div>
  );
}

export default VideoPlayer;
